export default {"src":"/_next/static/media/vendor-finance.fd01d211.svg","height":432,"width":552};